import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { PosShell } from "../pos/PosShell";

// Staff sign in with their own admin account (no separate "staff" user type
// in the legacy schema — an admin login IS the staff account here).
export function PosProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-primary" data-testid="pos-auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/pos/login" replace />;
  }

  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <PosShell>{children}</PosShell>;
}
